import { ONE_STOP_HISTORY_REQUEST_ID } from 'domain/shared/oneStop';

export const MY_ACTIVITY_ROOT_PATH = '/my-activity';

export const useMyActivityRoute = () => {
  return {
    historyRoute: `/requests/:${ONE_STOP_HISTORY_REQUEST_ID}?`,
  };
};
